import './styles.scss';

export const WebSite = ({ inputs }) => (
  <div className="web-site">
    <p className="web-site__title">Sito</p>
    <div className="web-site__url">
      {inputs}
    </div>
  </div>
)